import { render, staticRenderFns } from "./VehicleLevelFilterComponent.vue?vue&type=template&id=8768a96e"
import script from "./VehicleLevelFilterComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleLevelFilterComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports